/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { DataSourceTypeDefinitionDto } from '../models/data-source-type-definition-dto';
import { datasourceTypesGet$Json } from '../fn/data-source-types/datasource-types-get-json';
import { DatasourceTypesGet$Json$Params } from '../fn/data-source-types/datasource-types-get-json';
import { datasourceTypesGet$Plain } from '../fn/data-source-types/datasource-types-get-plain';
import { DatasourceTypesGet$Plain$Params } from '../fn/data-source-types/datasource-types-get-plain';
import { datasourceTypesTypeDefinitionIdGet$Json } from '../fn/data-source-types/datasource-types-type-definition-id-get-json';
import { DatasourceTypesTypeDefinitionIdGet$Json$Params } from '../fn/data-source-types/datasource-types-type-definition-id-get-json';
import { datasourceTypesTypeDefinitionIdGet$Plain } from '../fn/data-source-types/datasource-types-type-definition-id-get-plain';
import { DatasourceTypesTypeDefinitionIdGet$Plain$Params } from '../fn/data-source-types/datasource-types-type-definition-id-get-plain';

@Injectable({ providedIn: 'root' })
export class DataSourceTypesApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `datasourceTypesGet()` */
  static readonly DatasourceTypesGetPath = '/datasource-types';

  /**
   * List datasource types.
   *
   * Lists enabled datasource type definitions for UI wizard.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `datasourceTypesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  datasourceTypesGet$Plain$Response(params?: DatasourceTypesGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DataSourceTypeDefinitionDto>>> {
    const obs = datasourceTypesGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * List datasource types.
   *
   * Lists enabled datasource type definitions for UI wizard.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `datasourceTypesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  datasourceTypesGet$Plain(params?: DatasourceTypesGet$Plain$Params, context?: HttpContext): Observable<Array<DataSourceTypeDefinitionDto>> {
    const resp = this.datasourceTypesGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<DataSourceTypeDefinitionDto>>): Array<DataSourceTypeDefinitionDto> => r.body)
    );
  }

  /**
   * List datasource types.
   *
   * Lists enabled datasource type definitions for UI wizard.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `datasourceTypesGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  datasourceTypesGet$Json$Response(params?: DatasourceTypesGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DataSourceTypeDefinitionDto>>> {
    const obs = datasourceTypesGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * List datasource types.
   *
   * Lists enabled datasource type definitions for UI wizard.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `datasourceTypesGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  datasourceTypesGet$Json(params?: DatasourceTypesGet$Json$Params, context?: HttpContext): Observable<Array<DataSourceTypeDefinitionDto>> {
    const resp = this.datasourceTypesGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<DataSourceTypeDefinitionDto>>): Array<DataSourceTypeDefinitionDto> => r.body)
    );
  }

  /** Path part for operation `datasourceTypesTypeDefinitionIdGet()` */
  static readonly DatasourceTypesTypeDefinitionIdGetPath = '/datasource-types/{typeDefinitionId}';

  /**
   * Get datasource type.
   *
   * Gets a single datasource type definition (fields schema).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `datasourceTypesTypeDefinitionIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  datasourceTypesTypeDefinitionIdGet$Plain$Response(params: DatasourceTypesTypeDefinitionIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DataSourceTypeDefinitionDto>> {
    const obs = datasourceTypesTypeDefinitionIdGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get datasource type.
   *
   * Gets a single datasource type definition (fields schema).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `datasourceTypesTypeDefinitionIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  datasourceTypesTypeDefinitionIdGet$Plain(params: DatasourceTypesTypeDefinitionIdGet$Plain$Params, context?: HttpContext): Observable<DataSourceTypeDefinitionDto> {
    const resp = this.datasourceTypesTypeDefinitionIdGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<DataSourceTypeDefinitionDto>): DataSourceTypeDefinitionDto => r.body)
    );
  }

  /**
   * Get datasource type.
   *
   * Gets a single datasource type definition (fields schema).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `datasourceTypesTypeDefinitionIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  datasourceTypesTypeDefinitionIdGet$Json$Response(params: DatasourceTypesTypeDefinitionIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<DataSourceTypeDefinitionDto>> {
    const obs = datasourceTypesTypeDefinitionIdGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get datasource type.
   *
   * Gets a single datasource type definition (fields schema).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `datasourceTypesTypeDefinitionIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  datasourceTypesTypeDefinitionIdGet$Json(params: DatasourceTypesTypeDefinitionIdGet$Json$Params, context?: HttpContext): Observable<DataSourceTypeDefinitionDto> {
    const resp = this.datasourceTypesTypeDefinitionIdGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<DataSourceTypeDefinitionDto>): DataSourceTypeDefinitionDto => r.body)
    );
  }

}
